import React from 'react';
import { Button, darken, lighten, useTheme } from '@mui/material';
import { FaOptionIcon } from '@europrocurement/l2d-icons';
import { IconName } from '@fortawesome/fontawesome-svg-core';
import useSelectItem from '../FlexyDatatableTable/useSelectItem';

export type RowSelectionAction = {
    label: string;
    icon: string;
    onClick: (items: Array<unknown>) => void;
};

export type FlexyDatatableSelectionActionProps = RowSelectionAction;

export const FlexyDatatableSelectionAction: React.FunctionComponent<FlexyDatatableSelectionActionProps> =
    function (props) {
        const { label, icon = null, onClick } = props;
        const { selectedItems } = useSelectItem();
        const { palette } = useTheme();
        const isLightMode = palette.mode === 'light';

        const handleOnClick = () => {
            onClick(selectedItems);
        };

        const textColor = palette.getContrastText(palette.primary.main);
        const hoverBg = isLightMode
            ? lighten(palette.primary.main, 0.4)
            : darken(palette.primary.main, 0.4);

        return (
            <Button
                color="inherit"
                onClick={handleOnClick}
                sx={{
                    color: textColor,
                    display: 'flex',
                    gap: '5px',
                    alignItems: 'center',
                    fontSize: '13px',
                    fontWeight: '500',
                    lineHeight: '20.8px',
                    textAlign: 'left',
                    transition: 'all ease-in-out 300ms',
                    '&:hover': {
                        backgroundColor: hoverBg,
                    },
                }}
            >
                {icon && <FaOptionIcon icon={['fad', icon as IconName]} />}
                {label}
            </Button>
        );
    };
